<template>
  <v-container>
    <v-container>
      <v-row row justify="center">
        <v-col class="col-4" center>
          <div><label>Share this alert with your colleagues</label></div>
          <v-select
            class="share-select-input"
            v-model="selectedOption"
            :items="shareOptions"
            item-text="display"
            item-value="value"
            solo
            return-object
          ></v-select>
        </v-col>
      </v-row>
    </v-container>
    <UserShareListEditor
      v-if="displayMembersList"
      v-model="alert.share.list"
    ></UserShareListEditor>
  </v-container>
</template>

<script>
import { validateShare } from "@/services/alerts/alert.validation.js";
import { SHARE_OPTIONS } from "@/common/constants/alert.js";

const EMITTED_ACTIONS = {
  // NOTE: Emitted only after the step has been validated and will pass the validation results
  STEP_FINISHED: "step-finished",
};

export default {
  name: "ShareStep",
  components: {
    UserShareListEditor: () =>
      import("@/components/alerts/wizard/userShareList/UserShareListEditor"),
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      shareOptions: SHARE_OPTIONS,
      selectedOption: null,
    };
  },
  computed: {
    displayMembersList() {
      return this.selectedOption && this.selectedOption.id !== 1;
    },
  },
  watch: {
    isActive() {
      if (!this.isActive) {
        return;
      }
      this.selectedOption =
        this.alert.share && this.alert.share.type
          ? this.alert.share.type
          : SHARE_OPTIONS[0];
    },
    selectedOption() {
      this.alert.share.type = this.selectedOption;

      if (this.alert.share.type === SHARE_OPTIONS[0]) {
        this.alert.share.list = [];
      }

      this.validate();
    },
    ["alert.share.list"]() {
      this.validate();
    },
    ["alert.share.type"]() {
      if (this.alert.share.type.id) {
        this.selectedOption = this.alert.share.type;
      }
    },
  },
  methods: {
    validate() {
      if (!this.alert.share.type.id) {
        this.alert.share.type = SHARE_OPTIONS[0];
      }
      const isValid = validateShare(this.alert);
      this.$emit(EMITTED_ACTIONS.STEP_FINISHED, { isValid });
    },
  },
};
</script>

<style scoped>
.share-select-input >>> .v-input__slot {
  border-radius: 5px !important;
}
</style>
